import React from 'react'
import { Button, Tooltip } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import { useSecurityContext } from '../../Navigation/SecurityContext'
import { GraviButton } from '@gravitate-js/excalibrr'

export const OrderModalButton = ({ orderId, showModal, isDisabled = false }) => {
  const { scopes } = useSecurityContext()
  const orderReadScope = scopes.scopes.includes('o.r')

  const showOrderModalIcon = scopes?.create_order || orderReadScope
  const className = isDisabled ? 'info-button' : 'info-button p-1'
  return (
    <>
      {showOrderModalIcon && (
        <Tooltip title='View Order Details' mouseEnterDelay={0.5} placement='bottom'>
          <GraviButton
            size='small'
            disabled={isDisabled}
            icon={<FileTextOutlined />}
            onClick={(e) => showModal(orderId)}
          />
        </Tooltip>
      )}
    </>
  )
}
